// extracted by mini-css-extract-plugin
export default {"root":"BlockListingDetail_root__YTsva","media":"BlockListingDetail_media__eOh8U","text":"BlockListingDetail_text__Gttny"};